/**
 * Template types supported by the `mermaidd/template/*` endpoints. The backend
 * accepts these as the `template_type` / `templateType` discriminator across
 * list / upload / delete / download flows.
 */
export const TemplateType = {
  CHRONOLOGY: 'CHRONOLOGY',
  INDEX: 'INDEX',
} as const;

export type TemplateType = (typeof TemplateType)[keyof typeof TemplateType];

/**
 * One template as returned by `mermaidd/template/list`. `uploaded_at` is null
 * for templates whose upload has begun (`get-upload`) but not yet been
 * confirmed (`upload-complete`).
 */
export interface TemplateNode {
  templateId: string;
  templateName: string;
  blobPath: string;
  uploadedAt: string | null;
}
